import { render, staticRenderFns } from "./EditCCXStore.vue?vue&type=template&id=2b78d422&scoped=true"
import script from "./EditCCXStore.vue?vue&type=script&lang=ts"
export * from "./EditCCXStore.vue?vue&type=script&lang=ts"
import style0 from "./EditCCXStore.vue?vue&type=style&index=0&id=2b78d422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78d422",
  null
  
)

export default component.exports